import { findSubsidyTag } from '@lambda/reebelo/src/tagHelpers';
import cn from 'classnames';
import { PimProductT } from '@lambda/apis/src/dynamoDb/types';
import PurchaseLinks from './PurchaseLinks';
import SecondaryPriceInfo from './SecondaryPriceInfo';
import {
  ReplacedProduct,
  SelectionT,
} from '@/lib/collections/catalogue/helpers';
import { ShippingData } from '../collections/[handle]/NewProductPage/types';
import { DeliveryDateResponse } from '@/api/products/delivery-date';
import i18n from '@/settings/i18n';

const t = i18n.init();

type BottomBarT = {
  comparePrice: number | undefined;
  purchaseLinkOffer: ReplacedProduct;
  product: PimProductT;
  warrantyID: number | null;
  shippingData: ShippingData;
  deliveryDate: DeliveryDateResponse | undefined;
  selection: SelectionT;
  isUnfitProduct: boolean;
  actualPrice: number;
  isTradeInEligible: boolean;
  categoryPk: string;
};

const BottomBar = ({
  comparePrice,
  purchaseLinkOffer,
  product,
  warrantyID,
  shippingData,
  deliveryDate,
  selection,
  isUnfitProduct,
  actualPrice,
  isTradeInEligible,
  categoryPk,
}: BottomBarT) => (
  <div
    className="fixed bottom-0 left-0 z-50 w-full bg-white px-5 py-2.5 shadow-[0_-4px_9px_rgba(0,0,0,0.05)] lg:hidden"
    id="purchaseCont"
  >
    <div className="flex items-center justify-between">
      {/* Price Info */}
      <SecondaryPriceInfo
        actualPrice={actualPrice}
        comparePrice={comparePrice}
        isTradeInEligible={isTradeInEligible}
      />
      {/* ATC */}
      <PurchaseLinks
        offer={purchaseLinkOffer}
        vendor={purchaseLinkOffer.vendor}
        category={product.category}
        warranty={warrantyID}
        shippingData={shippingData}
        deliverBy={{
          min: deliveryDate?.standard.minDeliveryDate || '',
          max: deliveryDate?.standard.maxDeliveryDate || '',
        }}
        subsidyTag={findSubsidyTag(purchaseLinkOffer.tags)}
        productId={purchaseLinkOffer.productId}
        variantId={purchaseLinkOffer.variantId}
        key={`${purchaseLinkOffer.productId}#${purchaseLinkOffer.vendor}`}
        cartButtonVariant="dark"
        upgradation={
          purchaseLinkOffer.replacedFromCondition
            ? `${t(selection?.condition as string)} ${t`to`} ${t(
                purchaseLinkOffer.replacedFromCondition as string,
              )}`
            : undefined
        }
        comparePrice={comparePrice}
        className={cn('grid w-full max-w-[200px] grid-cols-1 px-2')}
        isOutOfStock={isUnfitProduct}
        categoryPk={categoryPk}
      />
    </div>
  </div>
);

export default BottomBar;
